export default {
  title: "Tâches",
  description: "Gérez vos tâches de mariage",
  taskList: "Liste des tâches",
  addTask: "Ajouter une tâche",
  editTask: "Modifier la tâche",
  deleteTask: "Supprimer la tâche",
  taskTitle: "Titre de la tâche",
  taskDescription: "Description de la tâche",
  dueDate: "Date d'échéance",
  priorityLabel: "Priorité",
  category: "Catégorie",
  assignedTo: "Assigné à",
  notes: "Notes",
  subtasks: "Sous-tâches",
  addSubtask: "Ajouter une sous-tâche",
  noTasks: "Aucune tâche trouvée",
  addFirstTask: "Ajoutez votre première tâche",
  taskDetails: "Détails de la tâche",
  save: "Enregistrer",
  cancel: "Annuler",
  delete: "Supprimer",
  edit: "Modifier",
  // view: "Voir", // Removed to avoid conflict with view object
  complete: "Terminer",
  incomplete: "Non terminé",
  confirmDelete: "Êtes-vous sûr de vouloir supprimer cette tâche ?",
  confirmDeleteTask: "Êtes-vous sûr de vouloir supprimer cette tâche ?",
  taskAdded: "Tâche ajoutée avec succès",
  taskUpdated: "Tâche mise à jour avec succès",
  taskDeleted: "Tâche supprimée avec succès",
  taskCreated: "Tâche créée avec succès",
  taskCompleted: "Tâche terminée avec succès",
  taskUncompleted: "Tâche marquée comme non terminée",
  totalTasks: "{{count}} tâches",
  pending: "{{count}} en attente",
  completed: "{{count}} terminées",
  search: "Rechercher des tâches",
  "tasks.dueDate": "Date d'échéance",
  
  view: {
    list: "Liste",
    kanban: "Kanban",
    boardView: "Vue tableau",
    calendarView: "Vue calendrier",
    listView: "Vue liste"
  },
  
  priority: {
    low: "Faible",
    medium: "Moyenne",
    high: "Haute",
    urgent: "Urgente"
  },
  
  status: {
    todo: "À faire",
    pending: "En attente",
    inProgress: "En cours",
    in_progress: "En cours",
    completed: "Terminé",
    cancelled: "Annulé",
    done: "Fait",
    overdue: "En retard"
  },

  statuses: {
    pending: "En attente",
    in_progress: "En cours",
    completed: "Terminé",
    cancelled: "Annulé"
  },
  
  categories: {
    planning: "Planification",
    venue: "Lieu",
    catering: "Traiteur",
    flowers: "Fleurs",
    photography: "Photographie",
    music: "Musique",
    attire: "Tenue",
    invitations: "Invitations",
    transportation: "Transport",
    decoration: "Décoration",
    legal: "Légal",
    beauty: "Beauté",
    other: "Autre",
    ceremony: "Cérémonie",
    reception: "Réception",
    vendors: "Prestataires",
    guests: "Invités",
    honeymoon: "Lune de miel"
  },
  
  filters: {
    title: "Filtres",
    all: "Toutes les tâches",
    pending: "En attente",
    completed: "Terminé",
    overdue: "En retard",
    today: "Pour aujourd'hui",
    thisWeek: "Pour cette semaine",
    thisMonth: "Pour ce mois",
    status: "Statut",
    category: "Catégorie",
    dueDate: "Date d'échéance",
    priority: "Priorité",
    priorityLabel: "Priorité",
    search: "Rechercher une tâche",
    sortBy: "Trier par",
    clear: "Effacer les filtres",
    reset: "Réinitialiser",
    assignee: "Assigné à",
    apply: "Appliquer",
    previous: "Précédent",
    next: "Suivant",
    options: {
      title: "Titre",
      dueDate: "Date d'échéance",
      priority: "Priorité",
      status: "Statut"
    }
  },
  
  sort: {
    dueDate: "Date d'échéance",
    priorityLabel: "Priorité",
    status: "Statut",
    title: "Titre",
    created: "Date de création"
  },
  
  dueDateWarning: "La date d'échéance approche",
  overdue: "En retard",
  dueToday: "Pour aujourd'hui",
  dueTomorrow: "Pour demain",
  dueThisWeek: "Pour cette semaine",
  dueNextWeek: "Pour la semaine prochaine",
  dueThisMonth: "Pour ce mois",
  dueNextMonth: "Pour le mois prochain",
  noDueDate: "Pas de date d'échéance",
  progress: "Progression",
  completionRate: "Taux d'achèvement",
  completedTasks: "Tâches terminées",
  pendingTasks: "Tâches en attente",
  overdueTasks: "Tâches en retard",
  taskProgress: "Progression des tâches",
  milestones: "Jalons",
  createMilestone: "Créer un jalon",
  milestoneTitle: "Titre du jalon",
  milestoneDate: "Date du jalon",
  milestoneDescription: "Description du jalon",
  milestoneAdded: "Jalon ajouté avec succès",
  milestoneUpdated: "Jalon mis à jour avec succès",
  milestoneDeleted: "Jalon supprimé avec succès",
  timeline: "Chronologie",
  ganttChart: "Diagramme de Gantt",
  searchPlaceholder: "Rechercher par titre ou description",
  noResults: "Aucune tâche ne correspond à votre recherche",
  clearSearch: "Effacer la recherche",
  export: "Exporter",
  import: "Importer",
  exportTasks: "Exporter les tâches",
  importTasks: "Importer des tâches",
  template: "Modèle",
  useTemplate: "Utiliser un modèle",
  weddingPlanningTemplate: "Modèle de planification de mariage",
  customTemplate: "Modèle personnalisé",
  templateApplied: "Modèle appliqué avec succès",
  bulkActions: "Actions groupées",
  selectAll: "Tout sélectionner",
  deselectAll: "Tout désélectionner",
  markCompleted: "Marquer comme terminé",
  markPending: "Marquer comme en attente",
  changeCategory: "Changer de catégorie",
  changePriority: "Changer de priorité",
  bulkDelete: "Suppression groupée",
  selectedTasks: "{{count}} tâches sélectionnées",
  bulkUpdateSuccess: "{{count}} tâches mises à jour avec succès",
  bulkDeleteSuccess: "{{count}} tâches supprimées avec succès",
  confirmBulkDelete: "Êtes-vous sûr de vouloir supprimer {{count}} tâches ?",
  dependencies: "Dépendances",
  addDependency: "Ajouter une dépendance",
  dependsOn: "Dépend de",
  blockedBy: "Bloqué par",
  blocks: "Bloque",
  noDependencies: "Aucune dépendance",
  attachments: "Pièces jointes",
  addAttachment: "Ajouter une pièce jointe",
  uploadFile: "Téléverser un fichier",
  downloadFile: "Télécharger le fichier",
  deleteFile: "Supprimer le fichier",
  fileUploaded: "Fichier téléversé avec succès",
  fileDeleted: "Fichier supprimé avec succès",
  comments: "Commentaires",
  addComment: "Ajouter un commentaire",
  commentPlaceholder: "Ajouter un commentaire...",
  commentAdded: "Commentaire ajouté avec succès",
  commentUpdated: "Commentaire mis à jour avec succès",
  commentDeleted: "Commentaire supprimé avec succès",
  noComments: "Pas encore de commentaires",
  notifications: "Notifications",
  reminders: "Rappels",
  setReminder: "Définir un rappel",
  reminderTime: "Heure du rappel",
  reminderSet: "Rappel défini avec succès",
  reminderDeleted: "Rappel supprimé avec succès",
  emailNotifications: "Notifications par email",
  pushNotifications: "Notifications push",
  recurring: "Récurrent",
  recurringTask: "Tâche récurrente",
  recurrencePattern: "Modèle de récurrence",
  daily: "Quotidien",
  weekly: "Hebdomadaire",
  monthly: "Mensuel",
  yearly: "Annuel",
  custom: "Personnalisé",
  endDate: "Date de fin",
  occurrences: "Occurrences",
  recurringTaskCreated: "Tâche récurrente créée avec succès",
  analytics: "Analytique",
  productivity: "Productivité",
  timeTracking: "Suivi du temps",
  startTimer: "Démarrer le minuteur",
  stopTimer: "Arrêter le minuteur",
  timeSpent: "Temps passé",
  estimatedTime: "Temps estimé",
  actualTime: "Temps réel",
  efficiency: "Efficacité",
  taskVelocity: "Vélocité des tâches",
  burndownChart: "Graphique d'avancement",
  velocityChart: "Graphique de vélocité",
  
  form: {
    title: "Titre de la tâche",
    description: "Description de la tâche",
    category: "Catégorie",
    priority: "Priorité",
    status: "Statut",
    dueDate: "Date d'échéance",
    new: "Nouvelle tâche",
    edit: "Modifier la tâche",
    titlePlaceholder: "Titre de la tâche",
    descriptionPlaceholder: "Description de la tâche",
    dueDatePlaceholder: "Date d'échéance",
    categoryPlaceholder: "Catégorie",
    priorityPlaceholder: "Priorité",
    statusPlaceholder: "Statut",
    assignedTo: "Assigné à",
    assignedToPlaceholder: "Responsable",
    notes: "Notes",
    notesPlaceholder: "Notes supplémentaires",
    submit: "Enregistrer",
    cancel: "Annuler",
    name: "Nom",
    assignee: "Assigné à",
    confirmCancel: "Êtes-vous sûr de vouloir annuler ? Les modifications non sauvegardées seront perdues.",
    errors: {
      titleRequired: "Le titre est requis",
      descriptionRequired: "La description est requise",
      submitFailed: "Erreur lors de l'enregistrement de la tâche",
      titleMinLength: "Le titre doit contenir au moins 3 caractères",
      statusRequired: "Le statut est requis",
      priorityRequired: "La priorité est requise",
      categoryRequired: "La catégorie est requise",
      dueDateRequired: "La date d'échéance est requise"
    }
  },
  
  actions: {
    edit: "Modifier",
    delete: "Supprimer",
    complete: "Terminer",
    moveTask: "Déplacer la tâche"
  },
  
  errors: {
    moveTask: "Erreur lors du déplacement de la tâche",
    loadFailed: "Échec du chargement des tâches",
    addFailed: "Échec de l'ajout de la tâche",
    updateFailed: "Échec de la mise à jour de la tâche",
    deleteFailed: "Échec de la suppression de la tâche",
    submit: "Erreur lors de la soumission de la tâche"
  },

  messages: {
    createSuccess: "Tâche ajoutée avec succès",
    updateSuccess: "Tâche mise à jour avec succès",
    deleteSuccess: "Tâche supprimée avec succès",
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer cette tâche ?",
    error: "Une erreur est survenue"
  },

  modal: {
    title: "Tâche",
    edit: "Modifier la tâche",
    delete: "Supprimer la tâche",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cette tâche ?"
  },
  
  sharing: {
    title: "Partager la liste de tâches",
    share: "Partager",
    success: "Liste de tâches partagée avec succès",
    readOnly: "Lecture seule",
    edit: "Modification",
    defaultMessage: "J'ai partagé une tâche avec vous",
    recipientEmail: "Email du destinataire",
    emailPlaceholder: "Entrez l'email du destinataire",
    recipientName: "Nom du destinataire",
    namePlaceholder: "Entrez le nom du destinataire",
    message: "Message",
    messagePlaceholder: "Entrez votre message",
    accessLevel: "Niveau d'accès"
  },

  demoTasks: {
    bookVenue: {
      title: "Réserver le lieu",
      description: "Trouver et réserver le lieu idéal pour la cérémonie et la réception"
    },
    orderInvitations: {
      title: "Commander les invitations",
      description: "Choisir et commander les invitations pour les invités"
    },
    bookCaterer: {
      title: "Réserver le traiteur",
      description: "Sélectionner et réserver le traiteur pour le repas de mariage"
    },
    chooseDress: {
      title: "Choisir la robe",
      description: "Trouver la robe de mariée parfaite"
    },
    bookPhotographer: {
      title: "Réserver le photographe",
      description: "Sélectionner et réserver le photographe pour immortaliser votre journée"
    },
    chooseRings: {
      title: "Choisir les alliances",
      description: "Trouver les alliances parfaites pour votre couple"
    }
  }
};
